import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { NodeStats } from './k8s-analyzer-node-status-panel';
import { getStatusColor } from './k8s-analyzer-node-status-panel';

interface StatusBoxProps {
  label: string;
  value: number;
  color: string;
}

const StatusBox: React.FC<StatusBoxProps> = ({ label, value, color }) => (
  <Box
    sx={{
      p: 2,
      borderRadius: 1,
      bgcolor: color,
      color: 'white',
      minWidth: 120,
      textAlign: 'center'
    }}
  >
    <Typography variant="h6">{value}</Typography>
    <Typography variant="body2">{label}</Typography>
  </Box>
);

interface PodStatusSummaryProps {
  nodeStats: Record<string, NodeStats>;
}

export const PodStatusSummary: React.FC<PodStatusSummaryProps> = ({ nodeStats }) => {
  // Calculate total pod counts by status across all nodes
  const totalPodsByStatus = Object.values(nodeStats).reduce((acc, node) => {
    const { pods } = node;
    // Add counts for each status type
    acc.Running = (acc.Running || 0) + pods.Running;
    acc.ContainerStatusUnknown = (acc.ContainerStatusUnknown || 0) + pods.ContainerStatusUnknown;
    acc.OOMKilled = (acc.OOMKilled || 0) + pods.OOMKilled;
    acc.Completed = (acc.Completed || 0) + pods.Completed;
    acc.Error = (acc.Error || 0) + pods.Error;
    return acc;
  }, {} as Record<string, number>);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={6}>
        <Typography variant="subtitle1" gutterBottom>
          Pod Status
        </Typography>
        <Grid container spacing={1}>
          {Object.entries(totalPodsByStatus).map(([status, count]) => (
            <Grid item key={status}>
              <StatusBox
                label={status}
                value={count}
                color={getStatusColor(status)}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PodStatusSummary; 